import { render, staticRenderFns } from "./BlogPostThumb.vue?vue&type=template&id=35b9bcc9"
import script from "./BlogPostThumb.vue?vue&type=script&lang=js"
export * from "./BlogPostThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports